/** Backplan mark and wordmark from the design system. `size` is the mark's width in px. */
export function Logo({ size = 28, wordmark = "text-lg leading-6" }: { size?: number; wordmark?: string }) {
  return (
    <span className="flex items-center gap-2.5">
      <svg width={size} height={size} viewBox="0 0 34 34" aria-hidden="true" className="shrink-0">
        <rect width="34" height="34" rx="10" className="fill-brand" />
        <rect x="14" y="8" width="13" height="4.5" rx="2.25" fill="#fff" />
        <rect x="9" y="14.75" width="18" height="4.5" rx="2.25" className="fill-accent" />
        <rect x="17" y="21.5" width="10" height="4.5" rx="2.25" fill="#fff" />
        <rect x="27.5" y="6" width="2" height="22" rx="1" fill="#fff" />
      </svg>
      <span className={`wordmark ${wordmark}`}>Backplan</span>
    </span>
  );
}
